import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InlineNotification, {LEVEL_WARNING, WARNING_TEXT_COLOR} from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import { connect } from 'react-redux';
import InlineButton from 'shared/components/InlineButton';
import _ from 'lodash';

@connect(state => ({
  supportLinkPolicy: state.general.supportLinks.supportLinkPolicy,
  permittedDomains: state.general.permittedDomains,
}))
export default class EbayLinkChecker extends Component {

  componentDidMount() {
    const linkValid = this.isLinkValid();
    const {onChange} = this.props;
    if (onChange) {
      onChange(linkValid);
    }
  }

  componentDidUpdate(prevProps) {
    const {onChange} = this.props;
    const linkValid = this.isLinkValid();
    if (this.isLinkValid(prevProps) !== linkValid) {
      if (onChange) {
        onChange(linkValid);
      }
    }
  }

  isLinkValid(props = this.props) {
    const {href, permittedDomains} = props;
    return _.isEmpty(href) || _.some(permittedDomains, permittedDomain => href.includes(permittedDomain));
  }

  render() {
    const {supportLinkPolicy, href, onChange, permittedDomains, ...other} = this.props;
    const linkProps = {
      style: {color: WARNING_TEXT_COLOR},
      target: '_blank',
      href: supportLinkPolicy,
    };
    return (
      <InlineNotification level={LEVEL_WARNING} open={!this.isLinkValid()} {...other}>
        This URL violates eBay's <InlineButton {...linkProps}>Links policy</InlineButton>.
        Links that direct customers to a site other than eBay are not allowed, except when linking to: <InlineButton {...linkProps}>Product videos, Freight shipping services</InlineButton>.
      </InlineNotification>
    );
  }
}

EbayLinkChecker.propTypes = {
  href: PropTypes.string,
  onChange: PropTypes.func,
};

EbayLinkChecker.defaultProps = {
};